// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BaseLayout_wrapper__2nCpm"};